export default __webpack_public_path__ + "assets/search-icon.d8ad1f83.svg";